export enum OfferStatusType {
    InPreparation = "IN PREPARATION",
    Processed = "PROCESSED",
    Ordered = "ORDERED",
    Cancelled = "CANCELLED"
}

export enum OrderStatusType {
    InProcess = "IN PROCESS",
    InPreparation = "IN PREPARATION",
    Shipped = "SHIPPED",
    Cancelled = "CANCELLED"
}